const pad = (num, size) => {
  var s = num + ""
  while (s.length < size) s = "0" + s
  return s
}

const toDuration = s => {
  const mm = Math.floor(s / 60) % 60
  const ss = Math.floor(s) % 60

  return `${pad(mm, 2)}:${pad(ss, 2)}`
}

export default toDuration
